/*
 *
 * SendDirectlyPopup
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 21-Jan-2025
 */

import SendDirectlyPopup from './SendDirectlyPopupContainer'

export default SendDirectlyPopup
